import { api } from "./lib/api"
import type { FormConfig } from "./types/form-types"
import { logger } from "./utils/logger"

export async function fetchFormConfig(
	formId: string,
	universityId: string,
	batchId: string,
): Promise<FormConfig | null> {
	try {
		const { data } = await api.get<FormConfig>(
			`/universities/${universityId}/batches/${batchId}/forms/${formId}`,
		)
		logger.info("[API] response of form fetch: ", data)
		return data
	} catch (e) {
		logger.error("[API] Failed to fetch form config:", e)
		return null
	}
}

export async function fetchWidgetConfig(
	widgetId: string,
	universityId: string,
): Promise<FormConfig | null> {
	try {
		const { data } = await api.get<FormConfig>(
			`/universities/${universityId}/widgets/${widgetId}`,
		)
		logger.info("[API] response of widget fetch: ", data)
		return data
	} catch (e) {
		logger.error("[API] Failed to fetch widget config:", e)
		return null
	}
}
